import React, { useContext } from 'react';
import CarouselThumbItem from './components/carousel-thumb-item/carousel-thumb-item';
import classNames from 'classnames';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './carousel.basic.scss';

const CarouselComponentBasic: React.FC<any> = props => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div
            className={classNames({
                'carousel-root': true,
                'carousel-root--mobile': isMobile,
                'carousel-root--single': props.children.length === 1
            })}
        >
            <div
                className={classNames({
                    'carousel': true,
                    'carousel-slider': true
                })}
            >
                <div className="slider-wrapper">
                    <ul className="slider animated" style={{ transform: 'translate3d(0px, 0px, 0px)', transitionDuration: '350ms' }}>
                        <li className="slide">
                            {
                                React.Children.map(props.children, (child, idx) => (
                                    React.cloneElement(
                                        child, { style: { display: idx === 0 ? 'flex' : 'none' } }
                                    )
                                ))
                            }
                        </li>
                    </ul>
                </div>
            </div>
            {(props.children.length > 1 && !isMobile) && (
                <div className="carousel">
                    <div className="thumbs-wrapper axis-vertical">
                        <ul
                            className="thumbs animated"
                            style={{ transform: 'translate3d(0px, 0px, 0px)', transitionDuration: '350ms' }}
                            role="tablist"
                        >
                            {
                                React.Children.map(props.children, (child, idx) => {
                                    return (
                                        <li
                                            key={child.key}
                                            className={classNames({
                                                thumb: true,
                                                selected: idx === 0
                                            })}
                                            aria-label={`slide item ${idx}`}
                                            role="tab"
                                        >
                                            <CarouselThumbItem
                                                alt={`image-${idx}`}
                                                image={child.key}
                                                totalPhotos={props.children.length}
                                                index={idx}
                                            />
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarouselComponentBasic;
